module.exports = __webpack_public_path__ + "static/media/logo.db69b24d.svg";